const selectColor = (colorNum: number, colors: number, sat: number = 100, light: number = 50): string => {
  if (colors < 1) colors = 1;
  return `hsl(${(colorNum * (360 / colors) % 360)},${sat}%,${light}%)`;
}

export default selectColor;